import { render, staticRenderFns } from "./PopUpVideoTwo.vue?vue&type=template&id=64fa587d&"
import script from "./PopUpVideoTwo.vue?vue&type=script&lang=js&"
export * from "./PopUpVideoTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports